import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[cardFactory]',
  standalone: false
})
export class CardFactoryDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
